const speakingPurple = '#8570A6';
const playbackLavender = '#B29DCB';
const inactiveWhite = 'rgba(255,255,255,1)';
const transparentWhite = 'rgba(255,255,255,0.8)';
export const colors = {
    speakingPurple,
    playbackLavender,
    inactiveWhite,
    transparentWhite,
};

export const fontWeights = {
    bold: '600',
};

export const fontSizes = {
    small: '0.9em',
    extraSmall: '0.8em',
    h2: '1.5em',
};
